import * as React from "react";

export class ModalCloseButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            className: '', value: '', onClick: null
        };
    }

    render() {
        return (
            <button id={this.props.id} type='button' className={'button button-secondary ' + this.props.className} onClick={this.props.onClick} data-dismiss='modal' style={{ paddingLeft: this.props.paddingLeft + 'px', paddingRight: this.props.paddingRight + 'px' }} > {this.props.value}</button >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/ModalCloseButton.js